// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ✅ مسیر صحیح و نهایی بر اساس ساختار استاندارد
import './assets/styles/global.css';
import 'katex/dist/katex.min.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);